import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'layers-arrow-up',
  size: 24,
  node: [
    ['path', { d: 'M12 12V2', key: '17ugg4' }],
    [
      'path',
      {
        d: 'M2 17.002a1 1 0 00.58.91l8.6 3.91a2 2 0 001.65 0l8.58-3.9a1 1 0 00.59-.92',
        key: '1ke1hd',
      },
    ],
    [
      'path',
      {
        d: 'M7.674 8.774 2.58 11.09a1 1 0 000 1.822l8.6 3.91a2 2 0 001.65 0l8.58-3.9a1 1 0 00.59-.92 1 1 0 00-.59-.922l-5.078-2.308',
        key: 'hlro1u',
      },
    ],
    ['path', { d: 'm9 5 3-3 3 3', key: 'l8vdw6' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name LayersArrowUp
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTIgMTJWMiIgLz4KICA8cGF0aCBkPSJNMiAxNy4wMDJhMSAxIDAgMDAuNTguOTFsOC42IDMuOTFhMiAyIDAgMDAxLjY1IDBsOC41OC0zLjlhMSAxIDAgMDAuNTktLjkyIiAvPgogIDxwYXRoIGQ9Ik03LjY3NCA4Ljc3NCAyLjU4IDExLjA5YTEgMSAwIDAwMCAxLjgyMmw4LjYgMy45MWEyIDIgMCAwMDEuNjUgMGw4LjU4LTMuOWExIDEgMCAwMC41OS0uOTIgMSAxIDAgMDAtLjU5LS45MjJsLTUuMDc4LTIuMzA4IiAvPgogIDxwYXRoIGQ9Im05IDUgMy0zIDMgMyIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/layers-arrow-up
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const LayersArrowUp = createLucideIcon(__iconData);

export default LayersArrowUp;
